module.exports = [
  {
    id: 1,
    title: "Perfect",
    quote:
      "Olmo streamlined our property operations. Tenant onboarding, rent collection, and maintenance tracking now take minutes instead of hours  a game changer!",
    stars: 5,
    image: "/images/users/user-1.png",
    name: "Mr Smith",
    company: "Business man",
    userType: "land-lord",
  },
  {
    id: 2,
    title: "Supper app",
    quote:
      "As a property manager, I love how Olmo centralizes everything. It saves time, reduces errors, and keeps my team fully aligned.",
    stars: 5,
    image: "/images/users/user-2.png",
    name: "Jack Sparrow",
    company: "Job Holder",
    userType: "tenant",
  },
  {
    id: 3,
    title: "Very Helpful",
    quote:
      "Rent payments are now instant and secure. Olmo has simplified our accounting process and improved tenant satisfaction dramatically.",
    stars: 5,
    image: "/images/users/user-3.png",
    name: "Robert Fox",
    company: "Developer",
    userType: "land-lord",
  },
  {
    id: 4,
    title: "Easy to use",
    quote:
      "Olmo made managing multiple properties effortless. Real-time updates and easy collaboration help us stay ahead of every issue.",
    stars: 5,
    image: "/images/users/user-4.png",
    name: "Adam",
    company: "Developer",
    userType: "tenant",
  },
  {
    id: 5,
    title: "Saves my time",
    quote:
      "Before Olmo, I was juggling spreadsheets and calls all day. Now everything from leases to reminders is handled in one place.",
    stars: 5,
    image: "/images/users/user-5.png",
    name: "Sarah Wilson",
    company: "Entrepreneur",
    userType: "land-lord",
  },
  {
    id: 6,
    title: "Stress free renting",
    quote:
      "I can view my rent history, submit issues, and track updates in seconds. Olmo makes renting clear and transparent.",
    stars: 5,
    image: "/images/users/user-6.png",
    name: "Emily Carter",
    company: "Student",
    userType: "tenant",
  },
  {
    id: 7,
    title: "Great for teams",
    quote:
      "Our whole property team uses Olmo daily. Tasks, notes, and follow-ups are synced so nothing falls through the cracks.",
    stars: 5,
    image: "/images/users/user-7.png",
    name: "Michael Lee",
    company: "Property Manager",
    userType: "land-lord",
  },
  {
    id: 8,
    title: "Reliable & modern",
    quote:
      "From digital payments to automated reminders, Olmo gives me the modern tools I need to manage my rental smoothly.",
    stars: 5,
    image: "/images/users/user-8.png",
    name: "Olivia Brown",
    company: "Job Holder",
    userType: "tenant",
  },
];
